<template>
  <ul class="defaultRadio">
    <li class="item" v-for="(item) in radioBtn" :key="item.id">
      <input type="radio"
             :id="item.id"
             :name="item.name"
             :checked="item.checked"
             :disabled="item.disabled"
             v-on:input="$emit('input', $event.target.id), checkItem($event.target.id)"
      >
      <label class="m-body-m" :class="{ disabled: item.disabled }" :for="item.id">{{item.value}}</label>
      <div class="check" :class="{ disabled: item.disabled }"></div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    radioBtn: Array
  },
  methods: {
    checkItem (target) {
      const radioButtons = this.radioBtn
      for (const item in radioButtons) {
        this.radioBtn[item].checked = radioButtons[item].id === target
      }
    }
  },
  mounted () {
    const radioButtons = this.radioBtn
    for (const item in radioButtons) {
      if (this.radioBtn[item].checked) {
        this.$emit('input', this.radioBtn[item].id)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.defaultRadio {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;

  .item {
    display: flex;
    position: relative;

    input[type=radio] {
      position: absolute;
      visibility: hidden;
    }

    label {
      z-index: 10;
      position: relative;
      padding: 0 0 0 30px;
      cursor: pointer;
      -webkit-transition: all 0.25s linear;
    }

    .check {
      display: flex;
      position: absolute;
      border: 1px solid var(--grey-200);
      border-radius: 100%;
      height: 16px;
      width: 16px;
      top: 3px;
      left: 0;
      z-index: 5;
      transition: border .25s linear;
      -webkit-transition: border .25s linear;

      &::before {
        display: flex;
        position: absolute;
        content: '';
        border-radius: 100%;
        height: 6px;
        width: 6px;
        top: 5px;
        left: 5px;
        margin: auto;
        transition: background 0.10s linear;
        -webkit-transition: background 0.10s linear;
      }
    }

    .check.disabled {
      background: var(--grey-240);
      border-color: var(--grey-240);
    }

    .m-body-m.disabled {
      color: var(--grey-200);
    }

    input[type=radio]:checked ~ .check {
      background: var(--second-base);
      border: 1px solid var(--second-base);
    }

    input[type=radio]:checked ~ .check::before{
      background: var(--main-base);
    }
  }

  .item + .item {
    margin: 12px 0 0 0;
  }
}
</style>
